import ArticleCard from "@components/Cards/ArticleCard";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import { twMerge } from "tailwind-merge";

export const ArticleStackCards = ({
  articles,
  sectionColor,
  refMedium,
  rootClassName,
}: {
  articles: ProcessedArticleData[];
  sectionColor?: string;
  refMedium?: string;
  rootClassName?: string;
}) => {
  return (
    <div
      className={twMerge(
        "flex flex-col md:flex-row gap-6 md:gap-4 text-base xmd:pt-5 xmd:pb-10",
        rootClassName,
      )}
    >
      <div className="w-full md:w-[53%] xmd:w-[55%] lg:w-1/2 text-100 xmd:text-5xl">
        {articles
          .filter((_, i) => i === 0)
          .map((article) => (
            <ArticleCard
              key={article.id}
              displayWidth={632}
              displayHeight={474}
              {...article}
              elements={{
                hasParagraph: true,
                hasTruncated: true,
                hasDate: true,
              }}
              overrideStyle={{
                cardWrapper: "w-full flex flex-col lg:border-b-0 xmd:py-0",
                paragraphStyle:
                  "text-base text-grey-200 font-normal font-opensans",
                titleClass:
                  "font-bold font-primary text-100 lg:text-5xl hover:no-underline leading-11 xmd:leading-12 text-grey-500",
                titleStyle: { color: sectionColor },
                imageWrapperStyle: "w-full max-w-full",
                titleWrapper: "gap-0",
                dateClass: "font-opensans text-sm",
                imageStyle: "h-55",
              }}
              refMedium={refMedium}
            />
          ))}
      </div>
      <div className="flex-col lg:pl-lg lg:pr-0.5 flex gap-3 md:w-[47%] xmd:w-[45%] lg:w-1/2">
        {articles
          .filter((_, i) => i > 0)
          .map((article, i) => (
            <ArticleCard
              key={i}
              displayWidth={248}
              displayHeight={186}
              {...article}
              elements={{
                hasParagraph: false,
                hasDate: true,
              }}
              overrideStyle={{
                cardWrapper:
                  "w-full lg:w-full xmd:py-0 gap-2 xmd:gap-2 lg:gap-3",
                titleClass:
                  "font-bold font-primary text-base xmd:text-xl text-grey-500 hover:text-grey-500 hover:no-underline leading-5 xmd:leading-7.5",
                imageWrapperStyle:
                  "max-w-[140px] xmd:max-w-[248px] xmd:w-38 lg:w-54 xl:w-full",
                titleWrapper: "gap-0",
                imageStyle: "min-w-34 xmd:w-full",
                dateClass: "font-opensans text-sm",
              }}
              refMedium={refMedium}
            />
          ))}
      </div>
    </div>
  );
};
